import styled from 'styled-components';

export const AccordionStyle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 0.8rem;
  .divHeader {
    display: flex;
    padding: 0.5rem;
    .accordionTitle {
      display: flex;
      border: none;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      background-color: transparent;
      font-size: 22px;
      color: ${({ theme }) => theme.colors.secondary};
      cursor: pointer;
      padding: 0;
      p {
        margin: 0;
        font-weight: 27;
      }
    }

    .optionalIcons {
      display: flex;
      align-items: center;
      .buttonExpandMore {
        color: ${({ theme }) => theme.colors.primary};
        background-color: transparent;
        border: none;
        :hover {
          cursor: pointer;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    .containerButton {
      display: flex;
      justify-content: flex-end;
    }
    p {
      margin: 0;
    }
  }
`;
